import {h, Fragment} from "preact"
import { useAppState, useProductFilters, useStore } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import Products from "./Products"
import BottomToolbar from "./BottomToolbar"
import Skeleton from "./Skeleton"
import NoResults from "./NoResults"

export default function Category() {
    const appState = useAppState();
    const { response: { products }, loading } = appState
    const { filters } = useProductFilters();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ expandedFacet, setExpandedFacet ] = useState(null);

    useEffect(() => {
        const bodyEl = document.querySelector('body');
        (sidebarOpen && bodyEl)
            ?   bodyEl.classList.add('overflow-hidden')
            :   bodyEl.classList.remove('overflow-hidden');
    }, [ sidebarOpen ])

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    return (
        <div class="ns-serp">
            {foundProducts ? (
                <>
                    <Sidebar 
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        expandedFacet={expandedFacet}
                    />
                    <div class="ns-serp-inner">
                        <Toolbar 
                            toggleSidebar={toggleSidebar}
                            setExpandedFacet={setExpandedFacet}
                        />
                        <Products /> 
                        <BottomToolbar />
                    </div>
                </>
            ) : loading ? (
                <Skeleton />
            ) : (
                <NoResults />
            )}
        </div>        
    )
}
